<template>
  <div :class="{ show: show }" class="header-search">
    <!-- <svg-icon class-name="search-icon" icon-class="search" @click.stop="click" /> -->
    <!-- <div class="header-search-select-wrapper">
      <el-select
        ref="headerSearchSelect"
        v-model="search"
        :remote-method="querySearch"
        filterable
        default-first-option
        remote
        placeholder="请输入相关搜索条件"
        class="header-search-select"
        @change="change"
      >
        <el-option
          v-for="option in options"
          :key="option.item.path"
          :value="option.item"
          :label="option.item.title.join(' > ')"
        />
      </el-select>
      <el-button
        class="header-search-btn"
        icon="el-icon-search"
        @click="onSearchBtnClick"
        circle
        size="mini"
      />
    </div> -->
  </div>
</template>

<script>
  // fuse is a lightweight fuzzy-search module
  // make search results more in line with expectations
  import Fuse from "fuse.js";
  import path from "path";

  export default {
    name: "HeaderSearch",
    data() {
      return {
        search: "",
        options: [],
        searchPool: [],
        show: true,
        fuse: undefined,
      };
    },
    computed: {
      routes() {
        return this.$store.getters.permission_routes;
      },
    },
    watch: {
      routes() {
        this.searchPool = this.generateRoutes(this.routes);
      },
      searchPool(list) {
        this.initFuse(list);
      },
      show(value) {
        if (value) {
          document.body.addEventListener("click", this.close);
        } else {
          document.body.removeEventListener("click", this.close);
        }
      },
    },
    mounted() {
      this.searchPool = this.generateRoutes(this.routes);
    },
    methods: {
      click() {
        this.show = !this.show;
        if (this.show) {
          this.$refs.headerSearchSelect && this.$refs.headerSearchSelect.focus();
        }
      },
      close() {
        this.$refs.headerSearchSelect && this.$refs.headerSearchSelect.blur();
        this.options = [];
        this.show = false;
      },
      change(val) {
        const path = val.path;
        const query = val.query;
        if (this.ishttp(val.path)) {
          // http(s):// 路径新窗口打开
          const pindex = path.indexOf("http");
          window.open(path.substr(pindex, path.length), "_blank");
        } else {
          if (query) {
            this.$router.push({ path: path, query: JSON.parse(query) });
          } else {
            this.$router.push(path);
          }
        }
        this.search = "";
        this.options = [];
        this.$nextTick(() => {
          this.show = false;
        });
      },
      initFuse(list) {
        this.fuse = new Fuse(list, {
          shouldSort: true,
          threshold: 0.4,
          location: 0,
          distance: 100,
          minMatchCharLength: 1,
          keys: [
            {
              name: "title",
              weight: 0.7,
            },
            {
              name: "path",
              weight: 0.3,
            },
          ],
        });
      },
      // Filter out the routes that can be displayed in the sidebar
      // And generate the internationalized title
      generateRoutes(routes, basePath = "/", prefixTitle = [], query = {}) {
        let res = [];

        for (const router of routes) {
          // skip hidden router
          if (router.hidden) {
            continue;
          }

          const data = {
            path: !this.ishttp(router.path)
              ? path.resolve(basePath, router.path)
              : router.path,
            title: [...prefixTitle],
          };

          if (router.meta && router.meta.title) {
            data.title = [...data.title, router.meta.title];

            if (router.redirect !== "noRedirect") {
              // only push the routes with title
              // special case: need to exclude parent router without redirect
              res.push(data);
            }
          }

          if (router.query) {
            data.query = router.query;
          }

          // recursive child routes
          if (router.children) {
            const tempRoutes = this.generateRoutes(
              router.children,
              data.path,
              data.title,
              data.query
            );
            if (tempRoutes.length >= 1) {
              res = [...res, ...tempRoutes];
            }
          }
        }
        return res;
      },
      querySearch(query) {
        if (query !== "") {
          this.options = this.fuse.search(query);
        } else {
          this.options = [];
        }
      },
      ishttp(url) {
        return url.indexOf("http://") !== -1 || url.indexOf("https://") !== -1;
      },
      onSearchBtnClick() {
        if (this.search) {
          this.querySearch(this.search);
          // 如果有结果，自动选中第一个并跳转
          if (this.options.length > 0) {
            this.change(this.options[0].item);
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .header-search {
    font-size: 0 !important;

    .search-icon {
      cursor: pointer;
      font-size: 18px;
      vertical-align: middle;
    }

    .header-search-select-wrapper {
      display: inline-flex;
      align-items: center;
      position: relative;
    }

    .header-search-select {
      font-size: 18px;
      transition: width 0.2s;
      width: 0;
      overflow: hidden;
      background: transparent;
      border-radius: 0;
      display: inline-block;
      vertical-align: middle;

      ::v-deep .el-input__inner {
        width: 250px;
        height: 30px;
        background: #ffffffb3;
        border: 1px solid #a0c0f9;
        border-radius: 17px;
        box-shadow: none !important;
        vertical-align: middle;
        &::placeholder {
          color: #5d6779 !important; /* 你想要的颜色 */
        }
      }
    }

    .header-search-btn {
      margin-left: -36px;
      z-index: 2;
      position: relative;
      top: 2px;
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      font-size: 14px;
      color: #5b677b;
      /* 只显示图标，无背景 */
    }

    &.show {
      .header-search-select {
        width: 252px;
        margin-left: 10px;
      }
    }
  }
</style>
